// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__J05-H","hiddenCard":"Card_hiddenCard__1ONL4","black":"Card_black__3dqZ6","red":"Card_red__2yKI0","value":"Card_value__3y_Zg","suit":"Card_suit__goiX4"};